import {
  Box,
  Button,
  Center,
  Container,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
  Stack,
  Textarea,
  useToast,
  Icon,
  VStack,
  HStack,
  Text,
  Divider,
  Badge,
} from "@chakra-ui/react";
import { FiPhone, FiUser, FiMail, FiMapPin, FiHome, FiFileText, FiSettings } from "react-icons/fi";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/Card";
import { RawCitySelect } from "../../../components/select/CitySelect";
// AddressAutocomplete removed; using MapBoxField only
import MapBoxField from "../../../components/map/MapBoxField";
import client from "../../../helpers/Client";
import urlToId from "../../../helpers/UrlToId";
import useInterval from "../../../helpers/UseInterval";
import TicketTypeSelect from "../../../shared/components/IssueTypeSelect";
import AuthContext from "../../../contexts/Auth";
import { getProvinces, getDistricts as tkgmGetDistricts, getNeighborhoods, getStreets, getBuildings } from "../../../services/tkgm";
import SearchableSelect from "../../../components/inputs/SearchableSelect";

const formatPhoneNumber = (value) => {
  if (!value) return '';

  // Sadece rakamları al
  const numbers = value.replace(/\D/g, '');

  // 10 haneli sınır
  const limited = numbers.slice(0, 10);

  // Formatla: 5XX XXX XX XX
  if (limited.length >= 7) {
    return `${limited.slice(0, 3)} ${limited.slice(3, 6)} ${limited.slice(6, 8)} ${limited.slice(8, 10)}`;
  } else if (limited.length >= 4) {
    return `${limited.slice(0, 3)} ${limited.slice(3, 6)} ${limited.slice(6)}`;
  } else if (limited.length >= 1) {
    return `${limited.slice(0, 3)} ${limited.slice(3)}`;
  }
  return limited;
};

const cleanPhoneNumber = (number) => {
  const digits = String(number || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.length > 10 && digits.startsWith("90")) return digits.slice(-10);
  if (digits.length === 11 && digits.startsWith("0")) return digits.slice(1);
  if (digits.length > 10) return digits.slice(-10);
  return digits;
};

const formatPhoneNumberForAPI = (number) => "+90" + number;

export function SuccessBox({ ticketNumber }) {
  return (
    <Box>
      <Heading
        textAlign={"center"}
        color={"gray.800"}
        lineHeight={1.1}
        fontSize={{ base: "2xl", sm: "3xl", md: "4xl" }}
      >
        İş Emriniz Oluşturuldu
      </Heading>
      <Center>
        <Heading
          color={"red.900"}
          size="2xl"
          mt={{ base: 50, md: 60, lg: 70 }}
          mb={{ base: 50, md: 60, lg: 120 }}
        >
          {ticketNumber}
        </Heading>
      </Center>
      <Heading
        textAlign={"center"}
        color={"gray.800"}
        lineHeight={1.1}
        fontSize={{ base: "xl", sm: "xl", md: "xl" }}
      >
        Bu takip numarası ile istediğiniz zaman servis kaydınızın durumunu takip
        edebilirsiniz
      </Heading>
      <Center>
        <Link mt={4} href="/sorgu">
          Buraya tıklayarak sorgulama ekranına gidebilirsiniz.
        </Link>
      </Center>
    </Box>
  );
}

export function Inner() {
  const navigate = useNavigate();
  const auth = useContext(AuthContext);
  const [submitting, setSubmitting] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [fullname, setFullname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [kind, setKind] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [cities, setCities] = useState([]);
  const [addres, setAddres] = useState("");
  const [coords, setCoords] = useState(null); // {lat,lng}
  const [neighborhood, setNeighborhood] = useState("");
  const [districts, setDistricts] = useState([]);
  const [district, setDistrict] = useState("");
  const [street, setStreet] = useState("");
  const [doorNo, setDoorNo] = useState("");
  const [postcode, setPostcode] = useState("");
  const [ticketBody, setTicketBody] = useState("");
  const [errorData, setErrorData] = useState({});
  const [reseller, setReseller] = useState("");
  const [lockedResellerURL, setLockedResellerURL] = useState("");
  const [smsSecondsCounter, setSmsSecondsCounter] = useState();
  const [searchParams] = useSearchParams();
  const [isInitialized, setIsInitialized] = useState(false);
  const toast = useToast();
  const [tkgmProvinceName, setTkgmProvinceName] = useState("");
  const [cityUrlFromMap, setCityUrlFromMap] = useState("");
  // TKGM chain
  const [tkgmProvinces, setTkgmProvinces] = useState([]);
  const [tkgmProvinceQ, setTkgmProvinceQ] = useState("");
  const [tkgmProvinceId, setTkgmProvinceId] = useState("");
  const [tkgmDistricts, setTkgmDistricts] = useState([]);
  const [tkgmDistrictQ, setTkgmDistrictQ] = useState("");
  const [tkgmDistrictId, setTkgmDistrictId] = useState("");
  const [tkgmNeighborhoods, setTkgmNeighborhoods] = useState([]);
  const [tkgmNeighborhoodQ, setTkgmNeighborhoodQ] = useState("");
  const [tkgmNeighborhoodId, setTkgmNeighborhoodId] = useState("");
  const [tkgmStreets, setTkgmStreets] = useState([]);
  const [tkgmStreetQ, setTkgmStreetQ] = useState("");
  const [tkgmStreetId, setTkgmStreetId] = useState("");
  const [tkgmBuildings, setTkgmBuildings] = useState([]);
  const [tkgmBuildingQ, setTkgmBuildingQ] = useState("");
  const [tkgmBuildingId, setTkgmBuildingId] = useState("");
  const [tkgmCenterLatLng, setTkgmCenterLatLng] = useState(null);
  const [mapPolygons, setMapPolygons] = useState([]); // Array of latlng arrays
  const [mapPolylines, setMapPolylines] = useState([]);
  const [mapBuildingLatLng, setMapBuildingLatLng] = useState(null);
  const sessionResellerURL = auth?.data?.user?.employee?.reseller?.url || "";
  const employeeResellerURL = lockedResellerURL || sessionResellerURL;
  const effectiveReseller = reseller || employeeResellerURL;
  const effectiveCityUrl = cityUrlFromMap || (Array.isArray(cities) && cities.length > 0 ? cities[0]?.url : "") || city || "";

  const resolveCurrentUserResellerUrl = async () => {
    try {
      const resp = await client.get("/users/?is_me=true");
      const payload = resp?.data;
      const me = Array.isArray(payload)
        ? payload[0]
        : (Array.isArray(payload?.results) ? payload.results[0] : null);
      const url = me?.employee?.reseller?.url || "";
      if (url) {
        setLockedResellerURL(url);
        setReseller(url);
      }
      return url;
    } catch (_) {
      return "";
    }
  };

  useInterval(() => {
    if (smsSecondsCounter > 0) {
      localStorage.setItem("countdown", smsSecondsCounter - 1);
      setSmsSecondsCounter(smsSecondsCounter - 1);
    }
  }, 1000);

  const fetchCustomerCallback = (_phoneNumber) => {
    setCustomerLoading(true);
    const normalizedSearch = cleanPhoneNumber(phoneNumber || _phoneNumber || "");
    client
      .get("/customers/", {
        params: {
          search: normalizedSearch,
          phone_verified: true,
        },
      })
      .then((response) => {
        const data = response.data;
        if (data.length !== 1) {
          toast({
            "title": "Müşteri bulunamadı veya telefon numarası onaylı değil.",
            "status": "warning",
            duration: 10000,
            isClosable: true,
          })
        } else {
          const result = data[0];
          setFullname(result["first_name"] + result["last_name"]);
          setPhoneNumber(cleanPhoneNumber(result["phone_number"]));
          if (!employeeResellerURL) setCity(result["city"]);
          setEmail(result["user"]["email"]);
          if (!addres || addres.trim() === '') {
            setAddres(result["address"]);
          }
        }
        setCustomerLoading(false);
      });
  };

  useEffect(() => {  // Load stored countdown from local storage on load.
    const storedCountdown = localStorage.getItem("countdown");
    if (storedCountdown) setSmsSecondsCounter(storedCountdown);
  }, []);

  useEffect(() => {  // Fetch customer if phone_number is given at params.
    const _phoneNumber = searchParams.get("phone_number");
    if (_phoneNumber) {
      fetchCustomerCallback(_phoneNumber);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  useEffect(() => { // Set city, resellers and selected reseller via employee's reseller.
    if (!employeeResellerURL) return;
    setReseller(employeeResellerURL);
    client.get(employeeResellerURL).then((response) => {
      const _reseller = response.data;
      const _cities = _reseller.cities;
      setReseller(_reseller?.url || employeeResellerURL);
      if (Array.isArray(_cities) && _cities.length > 0) {
        setCities(_cities);
        const first = _cities[0];
        if (first?.url) setCityUrlFromMap(first.url);
        if (first?.url) setCity(first.url);
        if (first?.name) setTkgmProvinceName(first.name);
      }
      setIsInitialized(true);
    }).catch(() => {
      setIsInitialized(true);
    });
  }, [employeeResellerURL]);

  useEffect(() => {
    if (employeeResellerURL) return;
    // Şehir listesi lazım: TKGM il adına göre bayi filtrelemek için
    client.get('/public/cities/').then((response) => {
      setCities(response.data);
    }).catch(() => { });
  }, [employeeResellerURL]);

  useEffect(() => {
    (async () => {
      try {
        const items = await getProvinces();
        setTkgmProvinces(items);
      } catch (_) { }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (!tkgmProvinceId) { setTkgmDistricts([]); setTkgmDistrictId(""); return; }
      const items = await tkgmGetDistricts(tkgmProvinceId).catch(() => []);
      setTkgmDistricts(items);
      setTkgmDistrictId("");
      const p = (tkgmProvinces || []).find((x) => x.id === tkgmProvinceId);
      if (p?.center && p.center.length === 2) {
        setTkgmCenterLatLng({ lat: p.center[0], lng: p.center[1] });
      }
      // Draw province polygon if available
      if (p?.geometry?.coordinates && Array.isArray(p.geometry.coordinates)) {
        const latlngs = (p.geometry.coordinates[0] || []).map(([lon, lat]) => [lat, lon]);
        setMapPolygons([latlngs]);
      } else {
        setMapPolygons([]);
      }
      setMapPolylines([]);
      setMapBuildingLatLng(null);
    })();
  }, [tkgmProvinceId]);

  useEffect(() => {
    (async () => {
      if (!tkgmDistrictId) { setTkgmNeighborhoods([]); setTkgmNeighborhoodId(""); return; }
      const items = await getNeighborhoods(tkgmDistrictId).catch(() => []);
      setTkgmNeighborhoods(items);
      setTkgmNeighborhoodId("");
      const d = (tkgmDistricts || []).find((x) => x.id === tkgmDistrictId);
      if (d?.center && d.center.length === 2) {
        setTkgmCenterLatLng({ lat: d.center[0], lng: d.center[1] });
      }
      if (d?.geometry?.coordinates && Array.isArray(d.geometry.coordinates)) {
        const latlngs = (d.geometry.coordinates[0] || []).map(([lon, lat]) => [lat, lon]);
        setMapPolygons([latlngs]);
      } else {
        setMapPolygons([]);
      }
      setMapPolylines([]);
      setMapBuildingLatLng(null);
    })();
  }, [tkgmDistrictId]);

  useEffect(() => {
    (async () => {
      if (!tkgmNeighborhoodId) { setTkgmStreets([]); setTkgmStreetId(""); return; }
      const items = await getStreets(tkgmNeighborhoodId).catch(() => []);
      setTkgmStreets(items);
      setTkgmStreetId("");
      const n = (tkgmNeighborhoods || []).find((x) => x.id === tkgmNeighborhoodId);
      if (n?.geometry?.coordinates && Array.isArray(n.geometry.coordinates)) {
        const latlngs = (n.geometry.coordinates[0] || []).map(([lon, lat]) => [lat, lon]);
        setMapPolygons([latlngs]);
      } else {
        setMapPolygons([]);
      }
      setMapPolylines([]);
      setMapBuildingLatLng(null);
    })();
  }, [tkgmNeighborhoodId]);

  useEffect(() => {
    (async () => {
      if (!tkgmStreetId) { setTkgmBuildings([]); setTkgmBuildingId(""); return; }
      const items = await getBuildings(tkgmStreetId).catch(() => []);
      setTkgmBuildings(items);
      setTkgmBuildingId("");
      const s = (tkgmStreets || []).find((x) => x.id === tkgmStreetId);
      if (s?.geometry?.coordinates) {
        const coords = s.geometry.coordinates;
        // Handle both LineString and MultiLineString
        if (Array.isArray(coords[0][0])) {
          const lines = coords.map((seg) => (seg || []).map(([lon, lat]) => [lat, lon]));
          setMapPolylines(lines);
        } else {
          const line = (coords || []).map(([lon, lat]) => [lat, lon]);
          setMapPolylines([line]);
        }
      } else {
        setMapPolylines([]);
      }
      setMapBuildingLatLng(null);
    })();
  }, [tkgmStreetId]);

  useEffect(() => {
    if (!tkgmBuildingId) return;
    const b = (tkgmBuildings || []).find((x) => x.id === tkgmBuildingId);
    if (!b) return;
    // text often like "5 ()" -> extract number
    const m = String(b.text || "").match(/\d+/);
    if (m) setDoorNo(m[0]);
    if (b.coords && b.coords.length === 2) {
      const c = { lat: Number(b.coords[0]), lng: Number(b.coords[1]) };
      setCoords(c);
      setTkgmCenterLatLng(c);
      setMapBuildingLatLng(c);
    }
    // Build display address from chain
    const pTx = (tkgmProvinces.find(x => x.id === tkgmProvinceId)?.text) || "";
    const dTx = (tkgmDistricts.find(x => x.id === tkgmDistrictId)?.text) || "";
    const nTx = (tkgmNeighborhoods.find(x => x.id === tkgmNeighborhoodId)?.text) || "";
    const sTx = (tkgmStreets.find(x => x.id === tkgmStreetId)?.text) || "";
    const composed = [sTx, m ? `No: ${m[0]}` : null, nTx, dTx, pTx].filter(Boolean).join(", ");
    if (composed) setAddres(composed);
    if (nTx) setNeighborhood(nTx);
  }, [tkgmBuildingId]);
  useEffect(() => {
    if (!isInitialized || !city || city === '') return;
    if (employeeResellerURL) return;
    const cityID = urlToId(city)
    client.get(`/public/districts/?city=${cityID}`).then((response) => {
      setDistricts(response.data || []);
      setDistrict("");
    }).catch(() => {
      setDistricts([]);
      setDistrict("");
    });
  }, [isInitialized, city])

  const handleFieldChange = (fieldName, value) => {
    if (fieldName === 'phoneNumber') {
      const formatted = formatPhoneNumber(value);
      setPhoneNumber(formatted);
    }
  };

  const validateField = (fieldName, value) => {
    const newErrors = { ...errors };

    if (fieldName === 'phoneNumber') {
      if (!value || value.trim() === '') {
        newErrors.phoneNumber = 'Telefon numarası gereklidir';
      } else {
        const cleanValue = value.replace(/\s/g, '');
        if (cleanValue.length !== 10) {
          newErrors.phoneNumber = 'Telefon numarası 10 haneli olmalıdır';
        } else if (!cleanValue.startsWith('5')) {
          newErrors.phoneNumber = 'Telefon numarası 5 ile başlamalıdır';
        } else {
          delete newErrors.phoneNumber;
        }
      }
    }

    setErrors(newErrors);
    return !newErrors[fieldName];
  };

  const handleFieldBlur = (fieldName, value) => {
    setTouched({ ...touched, [fieldName]: true });
    validateField(fieldName, value);
  };

  const handleSubmit = async () => {
    let resellerUrl = effectiveReseller;
    if (!resellerUrl) resellerUrl = await resolveCurrentUserResellerUrl();
    let cityUrl = effectiveCityUrl;
    if (!cityUrl && resellerUrl) {
      try {
        const rr = await client.get(resellerUrl);
        const cs = rr?.data?.cities;
        if (Array.isArray(cs) && cs.length > 0) {
          setCities(cs);
          const first = cs[0];
          const u = first?.url || "";
          if (u) {
            setCityUrlFromMap(u);
            setCity(u);
            cityUrl = u;
          }
          const n = first?.name;
          if (n) setTkgmProvinceName(n);
        }
      } catch (_) { }
    }

    // Frontend validation
    const cleanedPhoneNumber = phoneNumber.replace(/\s/g, '');
    const localErrors = {};
    if (!cleanedPhoneNumber || cleanedPhoneNumber.length !== 10 || !cleanedPhoneNumber.startsWith('5')) {
      localErrors.phone_number = ["Telefon numarası 5 ile başlayan 10 hane olmalıdır"];
    }
    if (!fullname || fullname.trim() === '') {
      localErrors.full_name = ["Ad soyad gereklidir"];
    }
    // Şehir hâlâ backend için zorunlu
    if (!cityUrl) {
      localErrors.city = ["Şehir seçiniz"];
    }
    if (!resellerUrl) {
      localErrors.reseller = ["Hesabınıza bayi atanmadı"];
    }
    if (!addres || addres.trim() === '') {
      localErrors.address = ["Adres gereklidir"];
    }
    // Sokak/Kapı No/Posta Kodu zorunluluğu kaldırıldı
    if (!coords || typeof coords.lat !== 'number' || typeof coords.lng !== 'number') {
      localErrors.location = ["Lütfen harita üzerinde konum seçin"];
    }
    if (!kind) {
      localErrors.kind = ["İşlem türü seçiniz"];
    }
    if (!ticketBody || ticketBody.trim() === '') {
      localErrors.body = ["Açıklama gereklidir"];
    }
    setErrorData(localErrors);
    const hasErrors = Object.keys(localErrors).length > 0;
    if (hasErrors) {
      toast({ title: 'Eksik veya hatalı alanlar var', status: 'warning' });
      return;
    }
    setSubmitting(true);
    const latStr = coords ? Number(coords.lat).toFixed(8) : undefined;
    const lngStr = coords ? Number(coords.lng).toFixed(8) : undefined;
    const requestBody = {
      full_name: fullname,
      phone_number: formatPhoneNumberForAPI(cleanedPhoneNumber),
      reseller: resellerUrl,
      email: email,
      city: cityUrl || undefined,
      address: addres,
      neighborhood: neighborhood || undefined,
      latitude: latStr,
      longitude: lngStr,
      kind: kind,
      body: ticketBody,
    };
    client
      .post(`/tickets/`, requestBody)
      .then((response) => {
        setSubmitting(false);
        navigate("/is-emri/" + urlToId(response.data.url) + "/");
      })
      .catch((error) => {
        setErrorData(error.response.data || {});
        toast({ title: 'Oluşturma başarısız', status: 'error' });
        setSubmitting(false);
      });
  };

  const selectedCity = cities.find((c) => String(c.url) === String(city));
  const selectedCityName = selectedCity ? selectedCity.name : "";
  const selectedDistrict = districts.find((d) => String(d.url) === String(district));
  const selectedDistrictName = selectedDistrict ? selectedDistrict.name : "";
  const mapCenterQuery = selectedCityName ? `${selectedDistrictName ? selectedDistrictName + ", " : ""}${selectedCityName}, Türkiye` : "";

  const bgColor = 'white';
  const borderColor = 'gray.200';
  const inputBg = 'gray.50';
  const inputFocusBg = 'white';
  const textColor = 'gray.800';
  const placeholderColor = 'gray.500';

  return (
    <Box
      bg={bgColor}
      borderRadius="20px"
      border="1px solid"
      borderColor={borderColor}
      boxShadow="xl"
      overflow="hidden"
    >
      <Box
        bgGradient={'linear(135deg, blue.50 0%, purple.50 100%)'}
        p={6}
      >
        <HStack spacing={3}>
          <Icon as={FiFileText} boxSize={8} color={textColor} />
          <VStack align="start" spacing={0}>
            <Text fontSize="2xl" fontWeight="bold" color={textColor}>
              İş Emri Oluştur
            </Text>
            <Text fontSize="sm" color={'gray.600'}>
              İş emirleri
            </Text>
          </VStack>
        </HStack>
      </Box>

      <Box p={3}>
        <VStack spacing={2}>
          <Box as={"form"} onSubmit={(e) => { e.preventDefault(); }}>
            <Stack spacing={4}>
              <FormControl>
                <FormLabel color={"gray.700"} fontWeight="semibold">
                  <HStack spacing={2}>
                    <Icon as={FiPhone} />
                    <Text>Telefon Numarası</Text>
                  </HStack>
                </FormLabel>
                <InputGroup gap={2}>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiPhone} color={"gray.400"} />
                  </InputLeftElement>
                  <Input
                    type="tel"
                    placeholder="5XX XXX XX XX"
                    maxLength="13"
                    bg={inputBg}
                    border="1px solid"
                    borderColor={touched.phoneNumber && errors.phoneNumber ? 'red.300' : borderColor}
                    color={textColor}
                    _placeholder={{ color: placeholderColor }}
                    _hover={{ borderColor: 'blue.300' }}
                    _focus={{
                      borderColor: 'blue.500',
                      bg: inputFocusBg,
                      boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)'
                    }}
                    borderRadius="12px"
                    h="48px"
                    value={phoneNumber}
                    onChange={(e) => handleFieldChange('phoneNumber', e.target.value)}
                    onBlur={(e) => handleFieldBlur('phoneNumber', e.target.value)}
                    isInvalid={touched.phoneNumber && errors.phoneNumber}
                  />
                  <Button
                    bgGradient={'linear(135deg, blue.500 0%, purple.600 100%)'}
                    color="white"
                    _active={{
                      transform: "translateY(0px)",
                      boxShadow: "md"
                    }}
                    fontWeight="semibold"
                    transition="all 0.2s"
                    isLoading={customerLoading}
                    onClick={() => fetchCustomerCallback()}
                    minW={{ base: "80px", sm: "120px" }}
                    h="48px"
                    px={{ base: 2, sm: 4 }}
                    fontSize={{ base: "xs", sm: "sm" }}
                    whiteSpace="nowrap"
                    flexShrink={0}
                  >
                    <Text display={{ base: "none", sm: "block" }}>
                      Müşteriyi Çek
                    </Text>
                    <Text display={{ base: "block", sm: "none" }}>
                      Çek
                    </Text>
                  </Button>
                </InputGroup>
                {touched.phoneNumber && errors.phoneNumber && (
                  <FormHelperText color="red">
                    {errors.phoneNumber}
                  </FormHelperText>
                )}
                {errorData.phone_number &&
                  errorData.phone_number.map((e) => (
                    <FormHelperText key={e} color="red">
                      {e}
                    </FormHelperText>
                  ))}
              </FormControl>
              <FormControl isInvalid={errorData.full_name}>
                <FormLabel color={"gray.700"} fontWeight="semibold">
                  <HStack spacing={2}>
                    <Icon as={FiUser} />
                    <Text>Ad Soyad</Text>
                  </HStack>
                </FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiUser} color={"gray.400"} />
                  </InputLeftElement>
                  <Input
                    type="text"
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                    placeholder="Ad Soyad giriniz"
                    bg={inputBg}
                    border="1px solid"
                    borderColor={borderColor}
                    color={textColor}
                    _placeholder={{ color: placeholderColor }}
                    _hover={{ borderColor: 'blue.300' }}
                    _focus={{
                      borderColor: 'blue.500',
                      bg: inputFocusBg,
                      boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)'
                    }}
                    borderRadius="12px"
                    h="48px"
                  />
                </InputGroup>
                {errorData.full_name &&
                  errorData.full_name.map((e) => (
                    <FormHelperText key={e} color="red">
                      {e}
                    </FormHelperText>
                  ))}
              </FormControl>
              <FormControl isInvalid={errorData.email}>
                <FormLabel color={"gray.700"} fontWeight="semibold">
                  <HStack spacing={2}>
                    <Icon as={FiMail} />
                    <Text>E-posta</Text>
                  </HStack>
                </FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiMail} color={"gray.400"} />
                  </InputLeftElement>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="ornek@email.com"
                    bg={"white"}
                    border="2px"
                    borderColor={"gray.200"}
                    color={"gray.800"}
                    _placeholder={{
                      color: "gray.400",
                    }}
                    _hover={{
                      borderColor: "blue.300",
                    }}
                    _focus={{
                      borderColor: "blue.500",
                      boxShadow: "0 0 0 1px #3182ce",
                    }}
                  />
                </InputGroup>
                {errorData.email &&
                  errorData.email.map((e) => (
                    <FormHelperText color="red">{e}</FormHelperText>
                  ))}
              </FormControl>
              {/* Şehir alanı kaldırıldı: adres seçimleri artık haritadaki MapBox üzerinden yapılır */}

              {errorData.reseller &&
                errorData.reseller.map((e) => (
                  <FormHelperText color="red">{e}</FormHelperText>
                ))}
              <FormControl isInvalid={errorData.address}>
                <FormLabel color={"gray.700"} fontWeight="semibold">
                  <HStack spacing={2}>
                    <Icon as={FiHome} />
                    <Text>Adres</Text>
                  </HStack>
                </FormLabel>
                <Box mt={2}>
                  <MapBoxField
                    onSelect={({ address, lat, lng, neighborhood }) => {
                      if (address) setAddres(address);
                      if (typeof lat === 'number' && typeof lng === 'number') setCoords({ lat, lng });
                      if (neighborhood) setNeighborhood(neighborhood);
                    }}
                    onProvinceChange={(name) => setTkgmProvinceName(name)}
                  />
                  {coords && (
                    <HStack mt={2} spacing={3}>
                      <Badge colorScheme="blue" variant="subtle">Lat: {Number(coords.lat).toFixed(6)}</Badge>
                      <Badge colorScheme="purple" variant="subtle">Lng: {Number(coords.lng).toFixed(6)}</Badge>
                      {neighborhood ? <Badge colorScheme="green" variant="subtle">Mahalle: {neighborhood}</Badge> : null}
                    </HStack>
                  )}
                </Box>
                {errorData.address &&
                  errorData.address.map((e) => (
                    <FormHelperText color="red">{e}</FormHelperText>
                  ))}
                {errorData.location &&
                  errorData.location.map((e) => (
                    <FormHelperText color="red">{e}</FormHelperText>
                  ))}
              </FormControl>
              {/* TKGM Zinciri: İl → İlçe → Mahalle → Sokak → No (Searchable) */}
              <Divider />
              {/* TKGM zinciri bu formdan kaldırıldı; MapBox içinde aramalı seçimlerle yapılır */}
              {/* Sokak/Kapı No/Posta Kodu alanları kaldırıldı: MapBox'taki seçim adresi oluşturuyor */}
              <FormControl isInvalid={errorData.kind}>
                <FormLabel color={"gray.700"} fontWeight="semibold">
                  <HStack spacing={2}>
                    <Icon as={FiSettings} />
                    <Text>İşlem Türü</Text>
                  </HStack>
                </FormLabel>
                <TicketTypeSelect
                  option={kind}
                  setOption={setKind}
                  bg={"white"}
                  border="2px"
                  borderColor={"gray.200"}
                  color={"gray.800"}
                  _hover={{
                    borderColor: "blue.300",
                  }}
                  _focus={{
                    borderColor: "blue.500",
                    boxShadow: "0 0 0 1px #3182ce",
                  }}
                  placeholder="İşlem türü seçiniz"
                />
              </FormControl>
              <FormControl isInvalid={errorData.body}>
                <FormLabel color={"gray.700"} fontWeight="semibold">
                  <HStack spacing={2}>
                    <Icon as={FiFileText} />
                    <Text>Açıklama</Text>
                  </HStack>
                </FormLabel>
                <Textarea
                  value={ticketBody}
                  onChange={(e) => setTicketBody(e.target.value)}
                  placeholder="Problemi ve talebinizi kısa ve anlaşılır şekilde yazınız"
                  bg={inputBg}
                  border="1px solid"
                  borderColor={borderColor}
                  color={textColor}
                  _placeholder={{ color: placeholderColor }}
                  _hover={{ borderColor: 'blue.300' }}
                  _focus={{
                    borderColor: 'blue.500',
                    bg: inputFocusBg,
                    boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)'
                  }}
                  borderRadius="12px"
                  minH="120px"
                />
                {errorData.body &&
                  errorData.body.map((e) => (
                    <FormHelperText color="red">{e}</FormHelperText>
                  ))}
              </FormControl>
            </Stack>
            <Button
              fontFamily={"heading"}
              mt={8}
              w={"full"}
              bgGradient="linear(to-r, red.900,red.700)"
              color={"white"}
              _hover={{
                bgGradient: "linear(to-r, red.800,red.700)",
                boxShadow: "xl",
              }}
              isLoading={submitting}
              loadingText="Oluşturuluyor..."
              isDisabled={submitting}
              onClick={() => {
                handleSubmit();
              }}
            >
              Oluştur
            </Button>
          </Box>
        </VStack>
      </Box>
    </Box>
  );
}

export function TicketCreate() {
  return (
    <Box height={"88vh"} position={"relative"}>
      <Container
        display={"flex"}
        alignContent={"space-around"}
        flexDirection={"column"}
        flexWrap={"wrap"}
        maxW={"7xl"}
        columns={{ base: 1, md: 1 }}
      >
        <Stack spacing={4}>
          <Inner />
        </Stack>
      </Container>
    </Box>
  );
}
